import { Badge } from "@mui/material";
import { FileWithImage } from "./images-gallery.component";

interface GalleryImageItemProps {
	file: FileWithImage;
	onClick?: () => void;
	labImage?: boolean;
}

export const GalleryImageItem = ({ file, onClick, labImage }: GalleryImageItemProps) => {
	return (
		<Badge
			color={
				!file.shared_until || new Date(file.shared_until) > new Date()
					? "success"
					: "error"
			}
			invisible={!file.shared_ids || !file.shared_ids[0] || !labImage}
			variant="dot"
			overlap="circular"
			sx={{
				"& .MuiBadge-dot": {
					width: "12px",
					height: "12px",
					borderRadius: "50%",
					top: "8px",
					right: "4px",
				},
			}}
		>
			<div className="flex flex-col">
				<div
					onClick={onClick}
					className="flex cursor-pointer flex-col gap-2 w-20 overflow-hidden"
				>
					<div className="w-20 h-20 flex items-center justify-center rounded overflow-hidden border">
						<img
							src={file.image}
							alt={file.file_name ?? ""}
							className="object-cover w-full h-full"
						/>
					</div>
				</div>
			</div>
		</Badge>
	);
};
